@if (hasScore()) {
  <p-tag severity="secondary" class="ml-2" [value]="score() | appNumber: '1.2-2'" />
}
